import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-item-pending-indicator, myt-app-item-pending-indicator',
  templateUrl: './app-item-pending-indicator.component.html',
  styleUrls: ['./app-item-pending-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppItemPendingIndicatorComponent {
  @Input() active = false;
  @Input() label = 'Pending';
  @Input() compact = false;
  @Input() diameter = 12;
  @Input() ariaLabel = 'Pending activity';
}
